import React from "react";
import PropTypes from "prop-types";
import { partial } from "ramda";

import Input from "components/input";

import isOLO from "helpers/is_olo";
import { handleErrors } from "helpers/credit_cards";

function EditCreditCardAddress({
  card,
  handleUpdateField,
  onBlurValidateCCField,
}) {
  const hideForLoyalty = isOLO() ? "" : "hidden";

  return (
    <div className={`cc-address-form ${hideForLoyalty}`}>
      <div className="row">
        <label>Address 1</label>
        <Input
          id="edit-cred-card-address-address-1"
          autoComplete="address-line1"
          error={handleErrors("address1", card)}
          onBlur={partial(onBlurValidateCCField, ["address1", card])}
          onChange={partial(handleUpdateField, [card.cardUuid, "address1"])}
          placeholder="Street and number"
          required
          type="text"
          value={card.address1}
        />
      </div>
      <div className="row">
        <label>Address 2</label>
        <Input
          id="edit-cred-card-address-address-2"
          autoComplete="address-line2"
          error={handleErrors("address2", card)}
          onChange={partial(handleUpdateField, [card.cardUuid, "address2"])}
          placeholder="Apartment, suite, unit, etc"
          type="text"
          value={card.address2}
        />
      </div>
      <div className="row">
        <label>City</label>
        <Input
          id="edit-cred-card-address-city"
          error={handleErrors("city", card)}
          onBlur={partial(onBlurValidateCCField, ["city", card])}
          onChange={partial(handleUpdateField, [card.cardUuid, "city"])}
          required
          type="text"
          value={card.city}
        />
      </div>
      <div className="row">
        <label>State / Province</label>
        <Input
          id="edit-cred-card-address-state"
          error={handleErrors("state", card)}
          maxLength="2"
          onBlur={partial(onBlurValidateCCField, ["state", card])}
          onChange={partial(handleUpdateField, [card.cardUuid, "state"])}
          value={card.state}
        />
        <label className="zip">Zip / Postal Code</label>
        <Input
          id="edit-cred-card-address-postal-code"
          autoComplete="postal-code"
          error={handleErrors("zip", card)}
          maxLength="10"
          onBlur={partial(onBlurValidateCCField, ["zip", card])}
          onChange={partial(handleUpdateField, [card.cardUuid, "zip"])}
          required
          type="text"
          value={card.zip?.replace(/\s+/g, "")}
        />
      </div>
    </div>
  );
}

EditCreditCardAddress.propTypes = {
  card: PropTypes.shape({
    cardNumber: PropTypes.string,
    expiryMonth: PropTypes.string,
    expiryYear: PropTypes.string,
    cvv: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  handleUpdateField: PropTypes.func.isRequired,
  onBlurValidateCCField: PropTypes.func.isRequired,
};

export default EditCreditCardAddress;
